import { apiRequest } from './api';

export type UploadDocumentsResponse =
  | { results: { name: string; status: string; error?: string }[] }
  | { error: string };

/**
 * Upload one or more documents (PDFs) with metadata
 * @param formData FormData containing files and metadata
 * @returns API response
 */
export const uploadDocuments = async (formData: FormData): Promise<UploadDocumentsResponse> => {
  // apiRequest now handles FormData and returns parsed data
  return apiRequest<UploadDocumentsResponse>(`/admin/document-upload`, {
    method: 'POST',
    data: formData,
  });
};
